<template>
  <card class="card-user">
    <img
      slot="image"
      src="https://ununsplash.imgix.net/photo-1431578500526-4d9613015464?fit=crop&fm=jpg&h=300&q=75&w=400"
      :alt="user.firstname + user.lastname"
    />
    <div class="author">
      <a href="#">
        <img
          class="avatar border-gray"
          src="/static/img/default-avatar.png"
          :alt="user.firstname + user.lastname"
        />
        <h4 class="title">
          {{ user.firstname }} {{ user.lastname }}
          <br />
          <small>{{ user.email }}</small>
          <br />
          <small>{{ user.phonenumber }}</small>
        </h4>
      </a>
    </div>
    <!-- <p class="description text-center">"Lamborghini Mercy
      <br>Your chick she so thirsty
      <br>I'm in that two seat Lambo"
    </p>-->
    <section class="text-secondary" v-if="user.city">
      {{ $t('common.field.city') }}:
      <small class="text-muted pull-right">{{ user.city }}</small>
    </section>
    <section class="text-secondary" v-if="user.address">
      {{ $t('common.field.address') }}:
      <small class="text-muted pull-right">{{ user.address }}</small>
    </section>
    <section class="text-secondary" v-if="user.society">
      {{ $t('common.field.society') }}:
      <small class="text-muted pull-right">{{ user.society }}</small>
    </section>
    <section class="text-secondary" v-if="user.postalcode">
      {{ $t('common.field.postalcode') }}:
      <small class="text-muted pull-right">{{ user.postalcode }}</small>
    </section>
    <section class="text-secondary" v-if="user.phonenumber">
      {{ $t('common.field.phonenumber') }}:
      <small class="text-muted pull-right">{{ user.phonenumber }}</small>
    </section>
    <section class="text-secondary" v-if="user.mainDistributorId">
      {{ $t('app.labels.distributor') }}:
      <small class="text-muted pull-right">{{
        distributor(user.mainDistributorId)
      }}</small>
    </section>
    <section class="text-secondary" v-if="user.upperBodySize">
      {{ $t('common.field.upperBodySize') }}:
      <small class="text-muted pull-right">{{ user.upperBodySize }}</small>
    </section>
    <div slot="footer" class="text-center">
      <!-- <button href="#" class="btn btn-simple">
        <i class="fa fa-facebook-square"></i>
      </button>
      <button href="#" class="btn btn-simple">
        <i class="fa fa-twitter"></i>
      </button>
      <button href="#" class="btn btn-simple">
        <i class="fa fa-google-plus-square"></i>
      </button>-->
    </div>
  </card>
</template>
<script>
import Card from '@/components/UIComponents/Cards/Card.vue';

export default {
  components: {
    Card,
  },
  props: {
    user: Object,
    distributors: Array,
  },
  methods: {
    distributor(value) {
      if (this.distributor && this.distributor.length > 0) {
        return this.distributors.find((x) => x._id === value).name;
      }
      return value;
    },
  },
};
</script>
<style></style>
